<template>
  <div class="room-setting-display-component">
    <div v-if="isRoomMode('group') || isRoomMode('exam')"
         class="room-setting-display-disable-wrapper">
      <p class="room-setting-display-disable--text">{{ setDisableText() }}</p>
    </div>
    <div v-else class="room-setting-display-wrapper">
      <div class="select-display-setting">
        <div class="room-setting-content-box">
          <h6 class="room-setting-content-title">{{ $t("setting.layout.type.title") }}</h6>
          <div class="room-setting-content-text-box">
            <div class="room-setting-content-text">{{ $t("setting.layout.type.message") }}</div>
          </div>
          <div class="room-setting-input-box">
            <div class="room-set-block-btn-box">
              <ul>
                <li v-for="displayMode in displayModeList"
                    :key="displayMode.type"
                    :class="[{ 
                      selected : selected.displayMode === displayMode.type,
                      }]"
                    @click="onClickDisplayMode(displayMode)">
                  <button class="room-set-block-btn" tabindex="1">{{ displayMode.name }}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="room-setting-content-box">
          <h6 class="room-setting-content-title">{{ $t("setting.layout.set.title") }}</h6>
          <div class="room-setting-content-text-box">
            <p class="room-setting-content-text">{{ $t("setting.layout.set.message") }}</p>
          </div>
          <!-- <div class="room-setting-input-box">
            <div v-if="isWallModeSelected" class="">
              <p>&#60;{{ $t("setting.chat.participant") }}&#62;</p>
              <img :src="require('@/assets/images/layout/ml_01_00.jpg')" />
            </div>
            <div class="video-layout-preview">
              <p>{{ isWallModeSelected ? `&#60;${$t('setting.layout.emcee')}&#62;` : `&#60;${$t('setting.layout.both')}&#62;`}}</p>
              <div class="video-layout-preview-img flex justify-center">
                <img :src="require(`@/assets/images/layout/${isLiveModeSelected ? 'ml_01_00' : selectedVideoLayout}.jpg`)"
                    :width="isWallModeSelected ? '100%' : '55%'"/>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div class="room-setting-content-text-box mt-1">
          <p class="room-setting-content-text justify-center">{{ videoLayoutTypeDescription }}</p>
        </div> -->

        <!-- 탭 형태로 가져온 UI -->
        <div class="room-setting-input-box">
          <div class="room-set-block-btn-box">
            <ul>
              <li v-for="(layoutArr, type) in layoutTypeList[selectedDisplayMode]"
                  :key="type"
                  :class="{ selected : (selected.videoLayoutType || 'grid') === type }"
                  @click="onClickLayoutType(type)"
                  @touchend="onClickLayoutType(type)"
              >
                <button class="room-set-block-btn" tabindex="1">{{ layoutTypeName(type) }}</button>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="selectedLayoutList?.length"
             class="room-setting-input-box screen-layout-type-select"
             :class="{
                   'opacity-50 pointer-events-none': useWallModeTargetScreen && selectedWallModeTargetScreenType === 'speaker',
                 }"
        >
          <ul class="screen-layout-type">
            <li
                v-for="videoLayout in selectedLayoutList"
                :key="videoLayout"
                class="screen-layout-item"
                @mouseover="layoutExample = videoLayout"
            >
              <button :class="{
                        'selected' : selectedVideoLayout === videoLayout
                      }"
                      class="video-layout-type-btn"
                      @click="onClickLayout(videoLayout, $event)"
                      @touchend="onClickLayout(videoLayout, $event)"
              >{{ setLayoutNumber(videoLayout) }}</button>
              <div v-if="layoutExample !== ''" class="video-layout-preview-item">
                <img :src="require(`@/assets/images/layout/${isLiveModeSelected ? 'ml_01_00' : layoutExample}.jpg`)"
                    :width="isWallModeSelected ? '100%' : '55%'"/>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="room-setting-content-box mt-6" v-if="useWallModeTargetScreen && selected.videoLayoutType === 'wall'">
        <div class="select-wall-mode-target-screen">
          <h6 class="room-setting-content-title">{{ $t("setting.wall.layout.title") }}</h6>
          <div class="room-setting-content-text-box">
            <p class="room-setting-content-text" v-html="$t('setting.wall.layout.description')"></p>
          </div>
          <div class="room-setting-input-box">
            <div class="room-set-block-btn-box">
              <ul>
                <li v-for="targetScreen in wallModeTargetScreenList"
                    :key="targetScreen.type"
                    :class="[{
                          selected : selectedWallModeTargetScreenType === targetScreen.type,
                          }]"
                    @click="onChangeWallModeTargetScreen(targetScreen.type)">
                  <button class="room-set-block-btn" tabindex="1">{{ targetScreen.name }}</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="room-setting-content-box mt-6" 
          v-if="selectedDisplayMode === displayModeList[1].type">
        <div class="select-qna-mode">
          <h6 class="room-setting-content-title">{{ $t("qna.list.btn") }}</h6>
          <div class="room-setting-content-text-box">
            <p class="room-setting-content-text">{{ $t("setting.layout.qna.text") }}</p>
          </div>
          <div class="room-setting-input-box">
            <label class="room-setting-label">
              <input :checked="useQnA" name="setQnaMode"
                     type="checkbox"
                     @input="CHANGE_SETTING_DATA({type: 'useQnA',value: $event.target.checked})">
              <span>{{ $t("common.use") }}</span>
            </label>
          </div>
        </div>
        <div class="select-qna-share-mode mt-8">
          <h6 class="room-setting-content-title">{{ $t("setting.layout.qna.share.title") }}</h6>
          <div class="room-setting-content-text-box">
            <p class="room-setting-content-text">{{ $t("setting.layout.qna.share.text") }}</p>
          </div>
          <div :class="{ disable : !useQnA }"
               class="room-setting-input-box">
            <label class="room-setting-label">
              <input :checked="useQnAShare" name="setQnaShareMode"
                     type="checkbox"
                     @input="CHANGE_SETTING_DATA({type: 'useQnAShare',value: $event.target.checked})">
              <span>{{ $t("common.share") }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {Device} from "@/utils";
import {debounce} from "lodash";

export default {
  data() {
    return {
      isWebviewApp: false,
      layoutExample: '',
      selected: { // UI 상으로 보여주기만 할 data, 실제 api로 전송되는 값은 params에 있음
        displayMode: null,
        videoLayoutType: null,
        videoLayout: null,
      },
      layoutTypeList: {
        discussion: {
          grid: [
            'auto', 'ml_01_00', 'ml_02_00', 'ml_03_00', 'ml_04_00',
            'ml_05_00', 'ml_06_00', 'ml_07_00', 'ml_08_00', 'ml_09_00',
            'ml_10_00', 'ml_11_00', 'ml_12_00', 'ml_13_00', 'ml_16_00',
            'ml_17_00', 'ml_19_00', 'ml_20_00', 'ml_22_00', 'ml_25_00',
            'ml_30_00', 'ml_33_00', 'ml_36_00', 'ml_40_00', 'ml_43_00',
            'ml_46_00', 'ml_49_00', 'ml_49_01', 'ml_56_00', 'ml_58_00',
            'ml_61_00', 'ml_64_00', 'ml_81_00', 'ml_100_00'
          ],
          announce: [
            'ml_02_03', 'ml_05_01', 'ml_11_01', 'ml_12_01',
            'ml_21_00', 'ml_22_01', 'ml_31_00', 'ml_31_01',
            'ml_32_00', 'ml_32_01', 'ml_41_00', 'ml_41_01',
            'ml_42_00', 'ml_42_01'
          ],
        },
        presentation: {
          live: [],
          wall: [
            'ml_01_00', 'ml_04_00', 'ml_05_00', 'ml_06_00', 'ml_07_00',
            'ml_08_00', 'ml_09_00', 'ml_10_00', 'ml_11_00', 'ml_12_00',
            'ml_13_00', 'ml_16_00', 'ml_17_00', 'ml_19_00', 'ml_20_00',
            'ml_22_00', 'ml_25_00', 'ml_30_00', 'ml_33_00', 'ml_36_00',
            'ml_40_00', 'ml_43_00', 'ml_46_00', 'ml_49_00', 'ml_56_00',
            'ml_58_00', 'ml_61_00', 'ml_64_00', 'ml_81_00', 'ml_100_00'
          ],
        },
      },
      wallModeTargetScreenList: [
          { type: 'grid', name: this.$t('setting.wall.layout.grid') },
          { type: 'speaker', name: this.$t('setting.wall.layout.speaker') }
      ]
    }
  },
  watch: {
    'selected': {
      deep: true,
      handler: function() {
        this.$emit('onUpdateScroll');
      }
    },
    'selected.videoLayoutType': {
      immediate: false,
      handler: function(layoutType) {
        const layoutList = this.layoutTypeList.presentation[layoutType];
        if(layoutList && !layoutList.includes(this.selectedVideoLayout)) {
          this.onClickLayout(null)
        }
      }
    },
  },
  computed: {
    ...mapGetters('room', [
      'room',
      'isRoomMode'
    ]),
    ...mapGetters('user', ['hasEmceeRole', 'isEmceeRole']),
    ...mapGetters('roomSetting', ['roomSetting', 'params']),
    ...mapGetters('call', [
      'currentVideoLayout',
      'currentWebinarType',
      'isWebinar',
      'isWebinarWall',
      'selectedWallModeTargetScreenType'
    ]),
    useQnA() {
      return this.params.useQnA
    },
    useQnAShare() {
      return this.params.useQnAShare
    },
    layoutTypeName() {
      return layoutType => {
        switch (layoutType) {
          case 'grid':
            return this.$t('setting.layout.grid.new')
          case 'announce':
            return this.$t('setting.layout.announce.new')
          case 'wall':
            return this.$t('setting.wall.new')
          case 'live':
            return this.$t('setting.live.new')
          default:
            return 'UNKNOWN'
        }
      }
    },
    setLayoutNumber() {
      return videoLayout => {
        if (videoLayout === 'auto') {
          return 'AUTO'
        }
        let splitNumber = videoLayout.split('_');
        let layoutNum = splitNumber[1]
        let layoutNum2 = splitNumber[2]

        if ((this.selected.videoLayoutType === 'announce' && layoutNum >= 31)
            || (this.selected.videoLayoutType === 'grid' && layoutNum == 49)) {
          layoutNum += layoutNum2 > 0 ? 'B' : 'A'
        }
        return layoutNum
      }
    },
    videoLayoutTypeDescription(){
      if(this.isLiveModeSelected)
        return this.$t('setting.live.description')
      if(this.isWallModeSelected)
        return this.$t('setting.wall.description')
      else
        return this.$t('setting.normal.description')
    },
    isParamWebinar() {
      return !!this.params.webinarType && this.params.webinarType !== 'none';
    },
    selectedLayoutType() {
      return this.selected.videoLayoutType || this.params.webinarType
    },
    isWallModeSelected() {
      return this.selectedLayoutType === 'wall'
    },
    isLiveModeSelected() {
      return this.selectedLayoutType === 'live'
    },
    selectedDisplayMode() {
      return this.selected.displayMode
          || ((this.isWallModeSelected || this.isLiveModeSelected) ? this.displayModeList[1].type : this.displayModeList[0].type)
    },
    selectedLayoutList() {
      return this.layoutTypeList[this.selectedDisplayMode][this.selectedLayoutType];
    },
    selectedVideoLayout() {
      return this.selected.videoLayout || this.params.videoLayout || this.currentVideoLayout
    },
    displayModeList(){
      return [
        {type: 'discussion', name: this.$t('setting.layout.discussion')},
        {type: 'presentation', name: this.$t('setting.layout.live')}
      ]
    },
    useWallModeTargetScreen() {
      return this.isEmceeRole && this.isWebinarWall && this.roomSetting?.useWallModeTargetScreen
    }
  },
  mounted() {
    this.initSelectedLayout();
  },
  methods: {
    ...mapActions('roomSetting', [
      'changeUseQnA',
      'changeUseQnAShare'
    ]),
    ...mapActions('call', [
        'changeWallModeTargetScreen'
    ]),
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
    isMobile() {
      return Device.isMobile();
    },
    onClickLayout: debounce(async function (videoLayout, event) {
      if (this.currentVideoLayout === videoLayout) {
        this.selected.videoLayout = null
      } else {
        this.selected.videoLayout = videoLayout
      }
      await this.CHANGE_SETTING_DATA({type: 'videoLayout', value: this.selected.videoLayout})
      const value = !!this.layoutTypeList.presentation[this.selected.videoLayoutType] && this.selected.videoLayoutType
      this.CHANGE_SETTING_DATA({type: 'webinarType', value})
    }, 100),
    onClickDisplayMode({type}) {
      this.selected.displayMode = type
    },
    onClickLayoutType(type) {
      this.selected.videoLayoutType = type
    },
    initSelectedLayout() {
      if (this.isParamWebinar) {
        this.selected.displayMode = this.displayModeList[1].type
        this.selected.videoLayoutType = this.params.webinarType
      } else {
        this.selected.displayMode = this.displayModeList[0].type
        this.layoutExample = this.params.videoLayout
        Object.entries(this.layoutTypeList[this.selected.displayMode]).forEach((layoutType) => {
          if (layoutType[1].includes(this.selectedVideoLayout))
            return this.selected.videoLayoutType = layoutType[0]
        })
      }
      this.selected.videoLayout = this.selectedVideoLayout;
    },
    setDisableText(){
      if(this.isRoomMode('group')) {
        return this.$t('setting.layout.disable.group');
      } else if(this.isRoomMode('exam')) {
        return this.$t('setting.layout.disable.exam');
      } else {
        return this.$t('setting.layout.disable.default');
      }
    },
    onChangeWallModeTargetScreen(targetScreen) {
      const sameTarget = this.params?.wallModeTargetScreen === targetScreen
      if (sameTarget) {
        console.log('## onChangeWallModeTargetScreen fail -> sameTarget:[%s]', sameTarget)
        return
      }
      this.CHANGE_SETTING_DATA({ type: 'wallModeTargetScreen', value: targetScreen })
      this.changeWallModeTargetScreen({ targetScreen: targetScreen });
    }
  },
}
</script>

<style lang='scss' scoped>
.room-setting-display-component {
  padding: 20px;
  position: relative;
  .room-setting-display-disable-wrapper {
    text-align: center;
    color: #999;
  }
  .room-setting-input-box {
    .screen-layout-type {
      display: flex;
      flex-wrap: wrap;
      // grid-template-columns: repeat(6, 1fr);    
    }

    .screen-layout-item {
      position: relative;
      display: flex;
      justify-content: center;
      width: 20%;
      height: 44px;
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;

      &:nth-child(-n+5) {
        border-top: 1px solid #ddd;
      }

      &:nth-child(5n+1) {
        border-left: 1px solid #ddd;
      }

      &:nth-child(5n+4), &:nth-child(5n) {
        .video-layout-preview-item {
          left: auto;
          right: 0;
        }
      }

      &:first-child {
        .video-layout-type-btn{
          font-size: 14px;
        }
      }

      &:hover .video-layout-preview-item {
        visibility: visible;
        top: -92px;
        opacity: 1;
      }

      .layout-preview {
        position: absolute;
        z-index: 7;
        background-color: #fff;
        border-radius: 10px;
        border: 1px #c4c4c4 solid;
        padding: 10px;

        .layout-preview-img {
          width: 100%;
          height: 100%;
        }

        .layout-preview-close-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 30px;
          height: 30px;
          background: url('~@/assets/images/x_white.svg') center/40% no-repeat;
        }
      }

      .video-layout-preview-item {
        position: absolute;
        top: -180%;
        left: 0;
        border: 1px solid blue;
        box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        transition: 100ms ease-out;
        visibility: hidden;
        z-index: 9;
        opacity: 0;
        pointer-events: none;

        > img {
          max-width: none;
          width: 160px;
          height: 90px;
        }
      }
    }

    .video-layout-type-btn {
      display: block;
      width: 100%;
      height: 100%;
      font-size: 16px;
      font-weight: bold;

      &:hover{
        background-color: #eee;
      }

      &.selected{
        background-color: #59f;
        color: white;
      }

      &:disabled{
        background: #ccc;
      }
    }
  }
}


.video-layout-preview-img {
  padding: 10px;
  background-color: #f1f1f1;
  text-align: center;

  > img {
    width: 160px;
    height: 90px;
  }
}

.live-start-btn-box {
  display: flex;
  justify-content: center;
  width: calc(100% - 15px);
  height: 100px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-top: 20px;
  background: #fff;

  .default-btn {
    width: calc(100% - 40px);
    height: 52px;
    border-radius: 4px;
    background-color: #59f;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    line-height: 52px;
    text-align: center;
    display: block;
    transition: 0.2s ease-out;

    &.stop {
      background-color: orange
    }

    &:hover {
      background-color: #1b59f6;
      color: #fff !important;
      text-decoration: none !important;
    }

    &:focus {
      outline: none;
      color: #fff !important;
      text-decoration: none !important;
    }
  }
}

.room-setting {
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;

    * {
      pointer-events: none;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.2s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(20%);
    opacity: 0;
  }
  50% {
    transform: translateY(-10%);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

[grm-device-mobile] {
  .room-setting-display-wrapper {
    max-height: calc(100vmax - 61px);
  }

  .live-start-btn-box {
    width: 100%;
  }
}
</style>